// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cropper-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 15px;
}

.cropper-modal {
  background: white;
  padding: 15px;
  border-radius: 8px;
  width: 95%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow: hidden;
}

.cropper-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.cropper-title {
  margin: 0;
  font-size: 18px;
  color: #262626;
}

.close-button {
  padding: 4px 8px;
  border: none;
  background: transparent;
  font-size: 20px;
  cursor: pointer;
}

.cropper-container {
  position: relative;
  height: 50vh;
  min-height: 250px;
  max-height: 400px;
  width: 100%;
}

.zoom-control {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
}

.zoom-control span {
  min-width: 60px;
  font-size: 14px;
}

.zoom-control input[type="range"] {
  appearance: none;
  width: 100%;
  height: 4px;
  background: #e1e1e1;
  border-radius: 5px;
  outline: none;
  padding: 0;
  margin: 0;
  position: relative;
  top: 2px;
}

.zoom-control input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  background: #1890ff;
  border-radius: 50%;
  cursor: pointer;
  -webkit-transition: background .15s ease-in-out;
  transition: background .15s ease-in-out;
  margin-top: -6px;
}

.zoom-control input[type="range"]::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #1890ff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  -moz-transition: background .15s ease-in-out;
  transition: background .15s ease-in-out;
}

.zoom-control input[type="range"]::-ms-thumb {
  width: 16px;
  height: 16px;
  background: #1890ff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  -ms-transition: background .15s ease-in-out;
  transition: background .15s ease-in-out;
}

.zoom-control input[type="range"]::-webkit-slider-thumb:hover {
  background: #40a9ff;
}

.zoom-control input[type="range"]::-moz-range-thumb:hover {
  background: #40a9ff;
}

.zoom-control input[type="range"]::-ms-thumb:hover {
  background: #40a9ff;
}

.zoom-control input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 4px;
  cursor: pointer;
  background: #e1e1e1;
  border-radius: 5px;
}

.zoom-control input[type="range"]::-moz-range-track {
  width: 100%;
  height: 4px;
  cursor: pointer;
  background: #e1e1e1;
  border-radius: 5px;
}

.zoom-control input[type="range"]::-ms-track {
  width: 100%;
  height: 4px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
}

.zoom-control input[type="range"]::-ms-fill-lower {
  background: #e1e1e1;
  border-radius: 5px;
}

.zoom-control input[type="range"]::-ms-fill-upper {
  background: #e1e1e1;
  border-radius: 5px;
}

.cropper-controls {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 10px;
}

@media (max-width: 768px) {
  .cropper-modal {
    width: 100%;
    height: 100%;
    max-height: none;
    border-radius: 0;
    padding: 10px;
  }

  .cropper-container {
    height: 40vh;
  }

  .cropper-controls {
    flex-direction: column;
    padding: 10px 0;
  }

  .cropper-controls button {
    width: 100%;
  }

  .zoom-control {
    padding: 15px;
  }

  .zoom-control input[type="range"] {
    height: 6px;
  }

  .zoom-control input[type="range"]::-webkit-slider-thumb {
    width: 20px;
    height: 20px;
  }

  .zoom-control input[type="range"]::-moz-range-thumb {
    width: 20px;
    height: 20px;
  }

  .zoom-control input[type="range"]::-ms-thumb {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 480px) {
  .cropper-overlay {
    padding: 0;
  }

  .cropper-container {
    height: 35vh;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/ImageCropper/ImageCropper.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4CAAuC;EAAvC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2CAAuC;EAAvC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".cropper-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 15px;\n}\n\n.cropper-modal {\n  background: white;\n  padding: 15px;\n  border-radius: 8px;\n  width: 95%;\n  max-width: 800px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  overflow: hidden;\n}\n\n.cropper-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.cropper-title {\n  margin: 0;\n  font-size: 18px;\n  color: #262626;\n}\n\n.close-button {\n  padding: 4px 8px;\n  border: none;\n  background: transparent;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.cropper-container {\n  position: relative;\n  height: 50vh;\n  min-height: 250px;\n  max-height: 400px;\n  width: 100%;\n}\n\n.zoom-control {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 20px;\n}\n\n.zoom-control span {\n  min-width: 60px;\n  font-size: 14px;\n}\n\n.zoom-control input[type=\"range\"] {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 4px;\n  background: #e1e1e1;\n  border-radius: 5px;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  top: 2px;\n}\n\n.zoom-control input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  background: #1890ff;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background .15s ease-in-out;\n  margin-top: -6px;\n}\n\n.zoom-control input[type=\"range\"]::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  background: #1890ff;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background .15s ease-in-out;\n}\n\n.zoom-control input[type=\"range\"]::-ms-thumb {\n  width: 16px;\n  height: 16px;\n  background: #1890ff;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background .15s ease-in-out;\n}\n\n.zoom-control input[type=\"range\"]::-webkit-slider-thumb:hover {\n  background: #40a9ff;\n}\n\n.zoom-control input[type=\"range\"]::-moz-range-thumb:hover {\n  background: #40a9ff;\n}\n\n.zoom-control input[type=\"range\"]::-ms-thumb:hover {\n  background: #40a9ff;\n}\n\n.zoom-control input[type=\"range\"]::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 4px;\n  cursor: pointer;\n  background: #e1e1e1;\n  border-radius: 5px;\n}\n\n.zoom-control input[type=\"range\"]::-moz-range-track {\n  width: 100%;\n  height: 4px;\n  cursor: pointer;\n  background: #e1e1e1;\n  border-radius: 5px;\n}\n\n.zoom-control input[type=\"range\"]::-ms-track {\n  width: 100%;\n  height: 4px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  border-width: 16px 0;\n  color: transparent;\n}\n\n.zoom-control input[type=\"range\"]::-ms-fill-lower {\n  background: #e1e1e1;\n  border-radius: 5px;\n}\n\n.zoom-control input[type=\"range\"]::-ms-fill-upper {\n  background: #e1e1e1;\n  border-radius: 5px;\n}\n\n.cropper-controls {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  padding: 10px;\n}\n\n@media (max-width: 768px) {\n  .cropper-modal {\n    width: 100%;\n    height: 100%;\n    max-height: none;\n    border-radius: 0;\n    padding: 10px;\n  }\n\n  .cropper-container {\n    height: 40vh;\n  }\n\n  .cropper-controls {\n    flex-direction: column;\n    padding: 10px 0;\n  }\n\n  .cropper-controls button {\n    width: 100%;\n  }\n\n  .zoom-control {\n    padding: 15px;\n  }\n\n  .zoom-control input[type=\"range\"] {\n    height: 6px;\n  }\n\n  .zoom-control input[type=\"range\"]::-webkit-slider-thumb {\n    width: 20px;\n    height: 20px;\n  }\n\n  .zoom-control input[type=\"range\"]::-moz-range-thumb {\n    width: 20px;\n    height: 20px;\n  }\n\n  .zoom-control input[type=\"range\"]::-ms-thumb {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .cropper-overlay {\n    padding: 0;\n  }\n\n  .cropper-container {\n    height: 35vh;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
